import { Grid2, Slider } from "@mui/material";
import React, { useState, useEffect } from "react";
//styles
import styles from "./BuyStaginStyles.module.scss";
import { CheckBox } from "@mui/icons-material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
export default function BuyStaging(props) {
  const {
    country,
    setQuantity,
    userDetails,
    isChecked: isCheckedProp,
    setIsChecked: setIsCheckedProp,
  } = props;
  const [internalChecked, setInternalChecked] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [baseAmount, setBaseAmount] = useState(60);
  const [taxAmount, setTaxAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);

  const isChecked =
    isCheckedProp !== undefined ? isCheckedProp : internalChecked;
  const setIsChecked = setIsCheckedProp || setInternalChecked;

  const marks = [
    { value: 0, label: "0hr" },
    { value: 15, label: "15hr" },
    { value: 30, label: "30hr" },
    { value: 45, label: "45hr" },
    { value: 60, label: "60hr" },
    { value: 75, label: "75hr" },
  ];

  useEffect(() => {
    const calculateAmounts = () => {
      const newBaseAmount = sliderValue * 1; // Assuming $12 per hour
      const taxRate = country === "India" && 0.18;
      const newTaxAmount = newBaseAmount * taxRate;
      const newFinalAmount = newBaseAmount + newTaxAmount;

      setBaseAmount(newBaseAmount);
      setTaxAmount(newTaxAmount);
      setFinalAmount(newFinalAmount);
    };

    calculateAmounts();
    setQuantity(parseInt(sliderValue, 10));
  }, [sliderValue, country, setQuantity]);

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
  };

  const handleCheck = () => {
    setIsChecked(!isChecked);
  };

  return (
    <Grid2>
      <Grid2 className={styles.sliderLabel}>Staging Environments</Grid2>
      <Grid2 className={styles.infoText}>
        Each site includes development, staging, and production environments
      </Grid2>
      <Grid2 className={styles.slider}>
        <Slider
          aria-label="Plan Slider"
          value={sliderValue}
          step={null}
          marks={marks}
          min={0}
          max={75}
          valueLabelDisplay="off"
          onChange={handleSliderChange}
          sx={{
            width: "90%",
            color: "#1976d2",
            height: 8,
            "& .MuiSlider-thumb": {
              height: 20,
              width: 20,
              backgroundColor: "white",
              border: "5px solid #1976d2",
              borderRadius: "50%",
              "&:hover, &.Mui-focusVisible": {
                boxShadow: "inherit",
              },
              "&.Mui-active": {
                boxShadow: "inherit",
              },
            },
            "& .MuiSlider-track": {
              height: 8,
              borderRadius: 4,
            },
            "& .MuiSlider-rail": {
              height: 8,
              borderRadius: 4,
              backgroundColor: userDetails === "dark" ? "#fff" : "#000",
            },
            "& .MuiSlider-mark": {
              height: 8,
              width: 8,
              backgroundColor: "white",
              borderRadius: "50%",
            },
            "& .MuiSlider-markLabel": {
              color: userDetails === "dark" ? "#fff" : "#000",
              fontSize: "14px",
              fontWeight: 500,
            },
          }}
        />
      </Grid2>
      <Grid2>
        <Grid2 className={styles.stagingAmount}>
          <Grid2>
            Staging Environment (
            <span className={styles.hour}>{sliderValue}hr</span>)
          </Grid2>
          <Grid2>{`${country === "India" ? "₹" : "$"}${baseAmount.toFixed(
            2
          )}/Month`}</Grid2>
        </Grid2>
        <hr className={styles.line} />
        {/* <Grid2 className={styles.coupon}>Add Coupon Code</Grid2> */}
        {country === "India" && (
          <Grid2 className={styles.stagingAmount2}>
            <Grid2>{country === "India" && "GST (18%)"}</Grid2>
            <Grid2>{`${country === "India" && "₹"}${taxAmount.toFixed(
              2
            )}/Month`}</Grid2>
          </Grid2>
        )}
        <Grid2 className={styles.stagingAmount3}>
          <Grid2>Sub Total</Grid2>
          <Grid2>{`${country === "India" ? "₹" : "$"}${finalAmount.toFixed(
            2
          )}/Month`}</Grid2>
        </Grid2>
        <hr className={styles.line} />
        <Grid2>
          <Grid2 className={styles.infoText1}>
            Your order may attract local taxes according to the billing
            information you give. The total cost might be different from the
            amount indicated here and will appear on your invoice.
          </Grid2>
          <Grid2 className={styles.checkContainer}>
            <Grid2
              className={styles.checkBox}
              onClick={() => {
                handleCheck();
              }}
            >
              {isChecked ? (
                <CheckBox className={styles.color} />
              ) : (
                <CheckBoxOutlineBlankIcon className={styles.color} />
              )}
            </Grid2>
            <Grid2 className={styles.infoText2}>
              I have read and agree to the terms and conditions
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
